import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-refresh",
  "use": "ico-refresh-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ico-refresh\">\n    <path d=\"M7.5 1C3.91406 1 1 3.91406 1 7.5C1 11.0859 3.91406 14 7.5 14C11.0859 14 14 11.0859 14 7.5V7H13V7.5C13 10.543 10.543 13 7.5 13C4.45703 13 2 10.543 2 7.5C2 4.45703 4.45703 2 7.5 2C9.14062 2 10.5977 2.72266 11.6055 3.85938L10.4648 5H14V1.46484L12.3125 3.15234C11.1211 1.83594 9.41016 1 7.5 1Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol